<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormSingleCheckboxInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormSingleCheckboxInput
}>()

const { t } = useI18n()
const { dt } = useDirectusTranslation()

const validation = computed(() => {
  return [
    props.data.required ? 'accepted' : null,
  ].join('|')
})
</script>

<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<FormKit
      :id="props.data.key"
      type="checkbox"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :validation-messages="{
        accepted: t('form.validation.generic_accepted'),
      }"
      :validation="validation"
      :classes="{
        messages: 'ml-2.8rem',
      }"
    >
      <template #decorator="context">
        <div
          class="grid mt-.2rem size-1.6rem place-items-center border-px"
          :class="context.value ? 'border-starline-primary text-starline-primary signature-page:text-signature signature-page:border-signature' : 'border-neutral-gray text-neutral-gray'"
        >
          <div v-if="context.value" class="i-radix-icons-check" />
        </div>
      </template>
      <template #label="context">
        <span class="link-text" v-html="context.label" />
      </template>
    </FormKit>
</FormKitLazyProvider>

  </div>
</template>

<style scoped>
:deep(.link-text > p > a) {
  text-decoration: underline !important;
}
</style>
